import React from 'react';
import { Foot } from './../../elements/SharedElements';

const Footer = () => (
    <Foot>
        <div className="container">
            <p>&copy; Copyright 2020 | <a target="_blank" rel="noreferrer" href="https://rathupap.co.za">Prince Rathupa</a> | All Rights Reserved.</p>
        </div>
    </Foot>
)

export default Footer;
